import { Injectable } from '@angular/core';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class RateService {

  constructor(private requestService: RequestService) { }
  
  // Rate an asset
  rate(params) {
    let req = {
      url: "/api/personalizedContent/addRate",
      req: {
        assetId: params.asset.id,
        rating: params.rating,
        seriesId: params.asset.seriesId ? params.asset.seriesId : 0
      }
    };

    return this.requestService.mainPostRequest(req);
  }

  // Remove items from rate list
  removeRates(ids) {
    let req = {
      url: "/api/personalizedContent/deleteRates",
      req: {
        //assetsIds: ids,
        ratesIds: ids
      }
    };
    return this.requestService.mainPostRequest(req);
  }

  // Get Bookmarks List
  getRates(params) {
    let req = {
      url: "/api/personalizedContent/getMyRates",
      req: {
        count: params.count ? params.count : 20,
        offset: params.offset ? params.offset : 0
      }
    };
    return this.requestService.mainPostRequest(req);
  }
}